export default __webpack_public_path__ + "71ab606914e3d690983bffde55d4ae7c.png";